import { createSelector } from "reselect";

const selectSharer = (state) => state.sharer;

export const selectUrlParams = createSelector(
  [selectSharer],
  (sharer) => sharer.urlParam
);

export const selectUrl = createSelector([selectSharer], (sharer) => sharer.url);

export const selectMode = createSelector(
  [selectSharer],
  (sharer) => sharer.apiMode
);

export const selectEmbedded = createSelector(
  [selectSharer],
  (sharer) => sharer.wp
);

export const selectPlatform = createSelector(
  [selectSharer],
  (sharer) => sharer.platform
);

export const selectCategories = createSelector(
  [selectSharer],
  (sharer) => sharer.categories
);

export const selectCategoryID = createSelector(
  [selectSharer],
  (sharer) => sharer.categoryID
);

export const selectMultirow = createSelector(
  [selectSharer],
  (sharer) => sharer.multirow
);
